import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import API_ROUTES_V2 from "~/api-routes-v2";
import apiService from "~/services/service";
import { z } from "zod";

function usePayslipUpload({ processId, fetchPayslipMatching }) {
  const [fileData, setFileData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [undoPayslip, setUndoPayslip] = useState(null);
  const [restoreMessage, setRstoreMessage] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
    setFileData(null);
  };
  const toastRef = useRef(null);

  const handleUndoPayslip = async () => {
    try {
      await apiService(API_ROUTES_V2.RESTORE_PAYSLIP_MATCHING_RESULT, "PUT", {
        replace: { id: undoPayslip?.id },
        body: {
          processId,
        },
        schema: z.object({
          processId: z.string().uuid(),
        }),
      });
      await fetchPayslipMatching();
      setRstoreMessage(
        `"${fileData?.extracted_data?.original_filename}" file has been restored.`,
      );
    } catch (error) {
      console.log("Payslip Undo failed", error);
    }
  };

  const handleDelete = async (matchingResultId) => {
    try {
      setIsLoading(true);
      await apiService(API_ROUTES_V2.PAYSLIP_MATCHING, "DELETE", {
        body: { processId },
        replace: { id: matchingResultId, status: "" },
        schema: z.object({
          processId: z.string().uuid(),
        }),
      });
      setShowModal(false);
      toastRef.current.show({
        severity: "error",
        summary: "File Deleted.",
        detail: `The file "${fileData?.extracted_data?.original_filename}" was deleted.`,
        icon: "pi pi-info-circle",
        otherAction: "Undo?",
        handleOtherAction: () => {
          toastRef?.current.clear();
          handleUndoPayslip();
        },
      });
      fetchPayslipMatching();
      setFileData(null);
    } catch (error) {
      console.log("Error deleting payslip", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleConfirm = (data) => {
    setFileData(data);
    setUndoPayslip(data);
    setShowModal(true);
  };

  return {
    showModal,
    handleCloseModal,
    handleDelete,
    isLoading,
    fileData,
    setFileData,
    setShowModal,
    toastRef,
    setUndoPayslip,
    handleConfirm,
    restoreMessage,
    setRstoreMessage,
  };
}

export default usePayslipUpload;
